// extracted by mini-css-extract-plugin
module.exports = {"efCheckbox":"checkbox_efCheckbox__KL3lj"};